<template>
    <div>
        <v-card to="/create/post/" v-if="isDesktop" flat outlined tile class="mb-8" height="100">
            <v-container fill-height justify-center>
                <p class="text-center my-0 title grey--text lighten-1 placeholder__text" ref="placeholderText">
                    <v-icon size=50 color="grey lighten-1">mdi-plus-circle-outline</v-icon> <span >Create a post</span>
                </p>
                <svg class="placeholder__svg" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
                    <rect fill="none" :stroke="$vuetify.theme.themes.light.secondaryDarker" x="0" y="0" width="100%" height="100%" stroke-dasharray=10 ref="placeholderRect" />
                </svg>
            </v-container>
        </v-card>
        <!-- recent uploads and user widget -->
        <!-- <widget-recent-uploads v-if="!isDesktop" class="pb-5"></widget-recent-uploads> -->
        
        <!-- Post listing -->
        <home-post-list></home-post-list>
    </div>
</template>
<style scoped>

.placeholder__svg {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 96%;
    height: 74%;
    transform: translateX(-50%) translateY(-50%);
}
</style>
<script>
import { gsap } from "gsap"
import homePostList from "./home-post-list.vue"
export default {
    components: {
        'home-post-list': homePostList
    },
    mounted() {
        this.$nextTick(() => {
            // Addpost animation only desktop
            if(this.isDesktop) this.addPostAnimation()
        })
    },

    methods: {
        // Draw animation for post
        addPostAnimation() {
            gsap.to(this.$refs.placeholderRect, {
                duration: 0.8,
                css: {
                    strokeDashoffset: 100
                },
                delay: 0.5
            })
        }
    }
}
</script>